export default __webpack_public_path__ + "static/kguthrie-d3bde0a3ee420436e1b1420c8ccef302.jpg";